import React, { createContext, useContext, useState, ReactNode } from 'react';

interface YearContextType {
  activeYear: number;
  setActiveYear: (year: number) => void;
}

const YearContext = createContext<YearContextType | undefined>(undefined);

export const YearProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [activeYear, setActiveYear] = useState<number>(new Date().getFullYear());

  return (
    <YearContext.Provider value={{ activeYear, setActiveYear }}>
      {children}
    </YearContext.Provider>
  );
};

export const useYear = () => {
  const context = useContext(YearContext);
  if (context === undefined) {
    throw new Error('useYear must be used within a YearProvider');
  }
  return context;
};
